import { gql } from 'urql';
import { PRODUCT } from '../client';

export const UPDATE_LOCATIONS_PRINT_DELIVERY_SHEET_ENABLED = gql`
  mutation ${PRODUCT}UpdateLocationsPrintDeliverySheetEnabled($input: LocationsPrintDeliverySheetEnabledUpdateInput!) {
    updateLocationsPrintDeliverySheetEnabled(input: $input) {
      locations {
        id
        printDeliverySheetEnabled
      }
    }
  }
`;
